<template>
    <div class="client-list">
        <h2 class="text-xl flex items-center"><span class="rounded-full h-6 w-1 bg-orange-500 inline-block mr-2"></span> Zoznam klientov ({{ clients.totalRecords }})</h2>
    
        <div class="fixed bottom-0 right-0 pb-6 pr-6 z-max">
            <md-button :to="{name: 'clients.create'}" class="md-fab md-primary">
                <md-icon>add</md-icon>
            </md-button>
        </div>
    
        <div class="client-list-items">
            <div class="table-header">
                <span class="w-1/5">Meno</span>
                <span class="w-1/5">Firma</span>
                <span class="w-1/6">ICO</span>
                <span class="w-1/6">Tel.</span>
                <span class="w-1/5">Dátum</span>
                <span class="ml-auto mr-2">Akcia</span>
            </div>
            <ClientItem v-for="client in clients.data" :key="`c`+client.id" :client="client" />
        </div>
        <ul class="flex pb-6 mt-6" v-if="hasClients && clients.totalPages > 0">
            <li
                v-ripple
                class="w-10 h-10 text-center py-2 px-1 text-gray-500 rounded-full mx-2 hover:bg-gray-100 cursor-pointer bg-white"
                :aria-disabled="isFirstPage"
                :disabled="isFirstPage"
                @click="() => this.jumpPage(1)"
            >
                <font-awesome icon="arrow-left"></font-awesome>
            </li>
            <li
                v-ripple
                class="w-10 h-10 text-center py-2 px-1 rounded-full mx-2 hover:bg-gray-100 cursor-pointer"
                v-for="page in pagesNumber"
                :key="'page'+page"
                :class="{'shadow-md bg-white text-white bg-orange-500 hover:bg-orange-400': page === clients.actualPage, 'text-gray-500 bg-white': page !== clients.actualPage}"
                @click="() => jumpPage(page)"
            >{{ page }}</li>
            <li
                v-ripple
                class="w-10 h-10 text-center py-2 px-1 text-gray-500 rounded-full mx-2 hover:bg-gray-100 cursor-pointer bg-white"
                :aria-disabled="isLastPage"
                :disabled="isLastPage"
                @click="() => this.jumpPage(clients.totalPages)"
            >
                <font-awesome icon="arrow-right"></font-awesome>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import ClientItem from "./ClientItem";

    export default {
        name: "ClientList",
        
        components: {
            ClientItem
        },
        
        data: () => ({
            page: 1,
            offset: 4
        }),
        
        computed: {
            ...mapState({
                clients: state => state.clients.all,
            }),

            hasClients() {
                return typeof this.clients !== 'object' && this.clients.data.length > 0;
            },
            
            // pagination
            isFirstPage() {
                return this.clients.actualPage === 1;
            },

            isLastPage() {
                return (
                    this.clients.totalPages === this.page
                );
            },

            pagesNumber() {
                let from = this.clients.actualPage - this.offset;
                if (from < 1) {
                    from = 1;
                }

                let to = from + this.offset * 2;
                if (to >= this.clients.totalPages) {
                    to = this.clients.totalPages;
                }

                let pagesArray = [];
                for (let page = from; page <= to; page++) {
                    pagesArray.push(page);
                }

                return pagesArray;
            }
        },
        
        mounted() {
            // if(this.clients.length === 0)
            this.fetchClients(this.page);
        },
        
        methods: {
            fetchClients(page = 1) {
                this.$store.dispatch("fetchClients", {paginate: true, limit: 25, page});
            },
            
            jumpPage(page) {
                this.fetchClients(page).then(r => {
                    window.scrollTo(0, 0);
                    this.$router.push({ query: { page } });
                });
            }
        }
    }
</script>

<style lang="scss">
    .client-list-items {
        @apply block;
        .table-header {
            @apply flex mt-6 mx-6;
        }
    }
</style>